module.exports = {
      id: "icon-audio-next-usage",
      viewBox: "0 0 35.504 35.504",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-audio-next",
      toString: function () {
        return this.url;
      }
    }